export default __webpack_public_path__ + "static/simple-column-9c43280cab6d4c599622ecbb311eb723.png";